import { Icon, Colors } from '@mercator-gcp/grout';
import Header from 'components/widgets/SearchFilterWizard/steps/components/Header';
import SectionWrapper from 'components/widgets/SearchFilterWizard/steps/components/SectionWrapper';

const CompletionStep = () => {
  return (
    <SectionWrapper
      sx={{
        gap: 'padding_24',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '300px',
      }}
    >
      <Icon name={Icon.Name.Check} size={64} fill={Colors.ForestGreen900} />
      <Header
        title="Filters all set!"
        description="Your project feed is now customised to your preferences."
      />
    </SectionWrapper>
  );
};

export default CompletionStep;
